import classNames from "classnames"

export function Button(props: React.HTMLAttributes<HTMLDivElement> & { ghost?: boolean }) {

  const { className, ghost, onClick, onKeyDown, ...pr } = props

  const isInteractive = !!onClick

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    onKeyDown?.(e)
    if (onClick && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault()
      onClick(e as unknown as React.MouseEvent<HTMLDivElement>)
    }
  }

  const a11y = isInteractive ? { role: "button", tabIndex: 0 } : {}

  if (ghost) {
    return <div className={classNames('box-border outline-none relative font-normal whitespace-nowrap text-center border border-solid cursor-pointer select-none font-sans text-sm leading-5 h-8 pt-1 px-4 rounded-md ', className)} onClick={onClick} onKeyDown={handleKeyDown} {...a11y} {...pr}>
      {props.children}
    </div>
  }

  return <div className={classNames('box-border outline-none relative font-normal whitespace-nowrap text-center border border-solid cursor-pointer select-none font-sans text-sm leading-5 h-8 pt-1 px-4 rounded-md text-white bg-blue-600 hover:bg-blue-500', className)} onClick={onClick} onKeyDown={handleKeyDown} {...a11y} {...pr}>
    {props.children}
  </div>

}
